export function setLocalTheme(data: string): any {
  localStorage.setItem("theme", data);
}

export function getLocalTheme(): any {
  return localStorage.getItem("theme") || "dark";
}

export function setLocalNetwork(data: string): any {
  localStorage.setItem("network", data);
}

export function getLocalNetwork(): any {
  return localStorage.getItem("network");
}

export function setLocalWallet(data: string): any {
  localStorage.setItem("wallet", data);
}

export function getLocalWallet(): any {
  return localStorage.getItem("wallet");
}
